// extracted by mini-css-extract-plugin
module.exports = {"projectTitleWrapper":"ProjectTitle_projectTitleWrapper__pyaIs","linkWrapper":"ProjectTitle_linkWrapper__mf6s9"};